export default __webpack_public_path__ + "static/media/ba94755e3580e10a4a4e3f9478a1eb9a1581618748763.3c8ff8fd.webp";